import { Dispatch } from "redux";
import {
  ERROR_LOADING_CONDITIONS,
  GET_ALL_CONDITIONS,
  RESET_DATA,
  START_LOADING_CONDITIONS,
  STOP_LOADING_CONDITIONS,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchConditionsAction =
  () => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_CONDITIONS });
    try {
      const currentState = getState();
      const queryString = generateQueryStringForUsers(
        currentState.Filters.conditionsFilter
      );

      const { data } =
        await apiLibrary.BehaviorsAndConditions.getAllConditions(queryString);
      dispatch({
        type: GET_ALL_CONDITIONS,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_CONDITIONS });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_CONDITIONS });
      // dispatch(loadingState(false))
    }
  };
